import { render, staticRenderFns } from "./DocumentValidate.vue?vue&type=template&id=3306e441&scoped=true"
import script from "./DocumentValidate.vue?vue&type=script&lang=js"
export * from "./DocumentValidate.vue?vue&type=script&lang=js"
import style0 from "./DocumentValidate.vue?vue&type=style&index=0&id=3306e441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3306e441",
  null
  
)

export default component.exports